import { render } from "./SecurityPolicyMessageModal.vue?vue&type=template&id=0d492e24"
import script from "./SecurityPolicyMessageModal.vue?vue&type=script&lang=js"
export * from "./SecurityPolicyMessageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__